import React from 'react';
import { Link } from 'react-router-dom';

export default function Forbidden() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
      <h1 style={{ fontSize: 32 }}>403</h1>
      <p>Você não tem permissão para acessar esta área.</p>
      <Link to="/" style={{ color: '#FF6A00' }}>Voltar para o início</Link>
    </div>
  );
}
